import { watch } from 'vue';
import { appState } from '@/appState';
/**
 * Watches the login for the session timeout: it fires on a login, a logout, and when a page reload reads the session again,
 * so whatever runs only while a session exists starts and stops here.
 */
export function setupSessionWatch() {
    watch(() => appState.isLoggedIn, (loggedIn) => {
        // TODO: move the session related timers here (legacyStore.js updateSessionTimeout and checkActivityAndRefreshSession, the activity in AppLayout.vue, the commit in axios.js)
        console.log(loggedIn ? 'logged in' : 'logged out');
    });
}
